module.exports = __webpack_public_path__ + "static/media/message_icon.c138efcc.svg";